import { LongRunningOperationStatus } from '../models/long-running-operation';

export const terminalLongRunningOperationStatuses: LongRunningOperationStatus[] = [
    LongRunningOperationStatus.Failed,
    LongRunningOperationStatus.Succeeded,
];

export const isLongRunningOperationInTerminalState = (status: string | undefined): boolean =>
    !!status && terminalLongRunningOperationStatuses.includes(status as LongRunningOperationStatus);
